<template lang="pug">
  v-container.daily-menu-offer-selector-container
    v-layout.daily-menu-offer-selector
      v-subheader.header
      v-container.subcontainer
        v-card.elevation-0
          v-flex()
            v-container
              v-layout.order( align-center column )
                v-flex.offer_title
                  span {{ $t('dailymenuPage.offerSummaryLabel') }}
                  span.selected_date() {{item.dayName}} {{item.formatedDate}}

          v-layout( v-if="!setFreeDay" align-stretch column)
            v-tabs(centered  v-model="tab" show-arrows next-icon="fas fa-arrow-right"
              prev-icon="fas fa-arrow-left")
              v-tab( v-for="(menuGroupItem, idx) in item.menuGroupList" :key="idx")
                | {{menuGroupItem.title}}
            v-tabs-items( v-model="tab"  )
              v-tab-item( v-for="(menuGroupItem, idx) in item.menuGroupList" :key="idx")
                offer-list-selector( :item="menuGroupItem" :countItems="item.menuGroupList.length"
                  :itemCollection="itemCollection" :allergensList="allergensList" @update="updateData(idx)")
          v-layout.justify-center( v-else )
            v-card-title {{ getEventName }}

</template>

<script lang="ts">
import Vue from 'vue'
import DailyMenuOffer from '@/model/dailymenu/DailyMenuOffer'
import OfferListSelector from '@/components/dailymenu/detail/OfferListSelector.vue'
import {IS_DATA_CHANGED} from '@/store/getter-types'
import {Component, Prop, Watch} from "vue-property-decorator"
import moment from "moment";
import FoodItem from "@/model/food-database/FoodItem";
import Allergen from "@/model/food-database/Allergen";

@Component({
  components: {
    OfferListSelector
  }
})
export default class DailyMenuOfferSelector extends Vue {

  @Prop({type: Object as () => DailyMenuOffer}) item!: DailyMenuOffer
  @Prop({type: Boolean}) setFreeDay!: boolean
  @Prop({type: String}) getEventName!: string
  @Prop({type: Array as () => FoodItem[]}) itemCollection!: FoodItem[]
  @Prop({type: Array as () => Allergen[]}) allergensList!: Allergen[]
  @Prop({type: Number || null}) index!: Number

  private tab: number = 0
  private day: string | null = null
  private date: string | null = null
  private changed: boolean = true

  @Watch('date')
  watchDate(newVal: any): void {
    if(newVal) {
      this.tab = 0
    }
  }

  get isDataChanged(): boolean {
    return this.$store.getters[IS_DATA_CHANGED]
  }

  getTabNumber() {
    if(this.index === 0) {
      this.tab = 0
    }else if(this.index === 1) {
      this.tab = 1
    }else if(this.index === 2) {
      this.tab = 2
    }else if(this.index === 3) {
      this.tab = 3
    } else {
      this.tab = 0
    }
  }

  @Watch('item')
  watchItem(newVal: any): void {
    if (newVal) {
      this.day = this.item.dayName
      this.date = moment(this.item.date).format("YYYY-MM-DD")
    }
  }

  @Watch('isDataChanged')
  watchIsDataChanged(newVal: boolean): void {
    this.changed = !newVal
  }

  updateData(index: any) {
    this.$emit('update',index)
  }

  mounted() {
    this.tab = 0
    if(this.index !== null) {
      this.getTabNumber()
    }
  }
}

</script>

<style lang="stylus" scoped>

.daily-menu-offer-selector-container {
  padding: 0;
  justify-items: start;
  justify-content: space-around;
  font-size: 1.2em
}

.daily-menu-offer-selector {
  flex-direction: column
}

.header {
  height: 0
}

.subcontainer {
  padding: 0
}

.groups {
  justify-items: stretch;
  justify-content: space-around;
  flex-direction: row;
  display: flex;
  align-items: stretch
}

.group {
  display: flex;
  flex: 1;
  margin: 1%
}

.selected_date {
  color: #008b8b
}

.spacer {
  width: 50px
}

.offer_title {
  font-size: 1.4em;
  text-align: center
}

.bgSuccess {
  background-color: #c0dbff !important
}

.bgStorno {
  background-color: #fbd457 !important;
  padding-bottom: 20px
}

.spacer_title {
  border-bottom: 1px dotted silver;
  border-top: 1px dotted silver
}

@media screen and (max-width: 960px) {
  .groups {
    flex-direction: column !important
  }
}
</style>
